// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"485":"d81622cd","595":"f37e3005"}[chunkId] + ".chunk.css";
};